
<h1 mat-dialog-title>Flight-Deck Admin Tools</h1>
<mat-dialog-content>
  <mat-tab-group dynamicHeight>
    <mat-tab label="Notes">
      <mat-card>
        <form #addNotesForm="ngForm" name="NotesForm" (ngSubmit)="onAddNote(addNotesForm)" novalidate>
          <mat-form-field #addAdminNoteMatFormField class="notes-field">
            <textarea class="addNotesTextArea" appAutoAdjustTextArea matInput #noteField placeholder="Write Note Here" name="note" [(ngModel)]="model.note" #note="ngModel"></textarea>
          </mat-form-field>
          <button class="mat-raised-button submit-button add-notes-submit-btn">
            Add Note
          </button>
        </form>
      </mat-card>
      <br/>
      <mat-form-field class="notesFilter">
        <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filter" >
      </mat-form-field>
      <mat-table #table matSort [dataSource]="dataSource" class="aopa-mat-table admin-business__table">

        <ng-container matColumnDef="commentDate">
          <mat-header-cell mat-sort-header *matHeaderCellDef class="data-block__label notes_update_date">Date</mat-header-cell>
          <mat-cell *matCellDef="let note" class="notes_update_date">{{note.commentDate | date:'short'}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="recid">
          <mat-header-cell mat-sort-header *matHeaderCellDef class="data-block__label notes_update_by">Rec Id</mat-header-cell>
          <mat-cell *matCellDef="let note" class="notes_update_by">{{note.recid}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="text">
          <mat-header-cell *matHeaderCellDef class="data-block__label">Note</mat-header-cell>
          <mat-cell *matCellDef="let note" class="data-block__value">
            <mat-form-field #adminNotesMatFormField class="notes-display-field">
              <textarea #noteTextArea appAutoAdjustTextArea class="noteTextArea" matInput placeholder="Note" [value]="note.text" [(ngModel)]="note.text"></textarea>
            </mat-form-field>
            <!-- cdkAutosizeTextarea -->
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef class="data-block__label note_actions">Actions</mat-header-cell>
          <mat-cell *matCellDef="let note" class="data-block__value note_actions">
            <button mat-icon-button (click)="onSaveNote(note)">
              <mat-icon aria-label="Saves the note">save</mat-icon></button>
            <button mat-icon-button (click)="onDeleteNote(note)">
              <mat-icon aria-label="Deletes the note">delete</mat-icon>
            </button>
            <span class="admin-airport__deleteConfirmationAdminNotes" *ngIf="shouldDisplayDeleteButtons(airportNotesToDelete, note)">
                  <button class="mat-raised-button submit-button" (click)="deleteNote(true, note)">Delete</button>
                  <button class="mat-raised-button submit-button" (click)="deleteNote(false, note)">Cancel</button>
                </span>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="['commentDate', 'recid', 'text', 'actions']"></mat-header-row>
        <mat-row *matRowDef="let row; columns: ['commentDate', 'recid', 'text', 'actions'];"></mat-row>
      </mat-table>
      <mat-paginator [pageSize]="4" [pageSizeOptions]="[2, 4, 8, 16]"></mat-paginator>
    </mat-tab>

    <mat-tab label="Add/Remove Manager">
      <div>
        <table class="data-block">
          <thead>
          <tr>
            <th class="data-block__label">Manager Name</th>
            <th class="data-block__label">AOPA Member Number</th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let admin of airport.admins; let i = index">
            <td class="data-block__value">
              {{admin.firstName}}&nbsp;{{admin.lastName}}
              <mat-icon *ngIf="!adminDeleteConfirmationArray[i]" (click)="onDeleteAdmin(i)" class="delete-icon"
                        mat-tooltip="Revoke admin permission from this business">delete_outline</mat-icon>
              <span class="admin-business__deleteConfirmation" *ngIf="adminDeleteConfirmationArray[i]">
                Delete? <button class="mat-raised-button submit-button" (click)="onDeleteConfirm(admin.recid, i)">Yes</button>
                <button class="mat-raised-button submit-button" (click)="onDeleteAdmin(i)">No</button>
              </span>
            </td>
            <td class="data-block__value">{{admin.recid}}</td>
          </tr>
          </tbody>
        </table>
        <form #addAdminForm name="form" (ngSubmit)="f.form.valid && onAddAdmin(f)" #f="ngForm" novalidate>
          <mat-form-field #addAdminMatFormField class="recid-field">
            <input #addAdminInput matInput placeholder="AOPA Member Number" type="text" name="recid" [(ngModel)]="model.recid" #recid="ngModel"
                   [ngClass]="{ 'is-invalid': f.dirty && model.recid.length > 0 && recid.invalid }" required minlength="2" maxlength="8" width="10"
                   (keyup)="onKeyUp()" ngModel />
          </mat-form-field>
          <button class="mat-raised-button submit-button add-admin-submit-btn">
            Add Admin
          </button>
          <div *ngIf="f.dirty && model.recid.length > 0 && recid.invalid" class="invalid-feedback">
            <div *ngIf="recid.errors.required">AOPA Member Number is required.</div>
            <div *ngIf="recid.errors.minlength">AOPA Member Number must be at least 2 digits.</div>
            <div *ngIf="recid.errors.maxlength">AOPA Member Number must be less than 9 digits.</div>
          </div>
        </form>
      </div>
    </mat-tab>

    <!-- <mat-tab label="Admin Dates">
      <div>
        <div *ngIf="lastVerifiedDate; else dateVerifiedPlaceholder">Last Verified: {{lastVerifiedDate}} by {{lastVerifiedBy}}</div>
        <div *ngIf="lastUpdateDate; else dateUpdatePlaceholder">Last Updated: {{lastUpdateDate}} by {{lastUpdateBy}}</div>
      </div>
    </mat-tab> -->

  </mat-tab-group>
</mat-dialog-content>
<mat-dialog-actions id="closeButton"><button mat-button mat-dialog-close>Close</button></mat-dialog-actions>
<ng-template #dateVerifiedPlaceholder>
  <div>Last Verified: None</div>
</ng-template>
<ng-template #dateUpdatePlaceholder>
  <div>Last Updated: None</div>
</ng-template>
